import { DialogActions, DialogTitle } from "@material-ui/core";
import React from "react";
import IAPI from "../../../../models/IAPI";
import IIntegration from "../../../../models/IIntegration";
import { RawLinkButton } from "../../../LinkButton";
import { handleAPISubmit, IHandleAPISubmitProps } from "../../functions/sharedFunctions";
import IntegrationAPISelectTable from "../../sections/apis/IntegrationAPISelectTable";

interface ISelectAPIsNonProdDialog {
  token: string;
  integration: IIntegration;
  currentApis: IAPI[];
  closeDialog: () => void;
  setIntegrationErrors: (val: string[]) => void;
  setApis: (val: IAPI[]) => void;
}

export const SelectAPIsNonProdDialog = (props: ISelectAPIsNonProdDialog) => {
  const { token, integration, currentApis, closeDialog, setIntegrationErrors, setApis } = props;
  const [selectedAPIs, setSelectedAPIs] = React.useState<IAPI[]>(currentApis);

  async function handleSelectAPIsSubmit() {
    let updateApis: IHandleAPISubmitProps = {
      token: token,
      integrationID: integration.ID,
      selectedApis: selectedAPIs,
      currentApis: currentApis,
      company: integration.Company,
      setIntegrationErrors: setIntegrationErrors,
    };

    let newAPIs: IAPI[] | undefined = await handleAPISubmit(updateApis);

    if (newAPIs) {
      setApis(newAPIs);
    }

    closeDialog();
  }

  return (
    <>
      <DialogTitle id="alert-dialog-title">{`Select APIs for ${integration.Name}`}</DialogTitle>
      <IntegrationAPISelectTable name={"Select APIs"} token={token} integration={integration} selectedAPIs={selectedAPIs} setSelectedAPIs={setSelectedAPIs} />
      <DialogActions>
        <RawLinkButton onClick={handleSelectAPIsSubmit} color="secondary">
          Confirm
        </RawLinkButton>
        <RawLinkButton onClick={closeDialog} color="primary">
          Cancel
        </RawLinkButton>
      </DialogActions>
    </>
  );
};
